import { useMemo } from "react";
import * as THREE from "three";
import { HERO_COLORS } from "./constants";

/**
 * Fresnel atmosphere — a slightly larger sphere rendered inside-out.
 * Purple/violet glow that intensifies along the silhouette.
 * Absolutely no blue.
 */
const VERT = /* glsl */ `
  varying vec3 vNormal;
  void main() {
    vNormal = normalize(normalMatrix * normal);
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

const FRAG = /* glsl */ `
  uniform vec3 uColor;
  uniform vec3 uColor2;
  uniform float uIntensity;
  varying vec3 vNormal;
  void main() {
    float intensity = pow(0.72 - dot(vNormal, vec3(0.0, 0.0, 1.0)), 2.3);
    vec3 col = mix(uColor, uColor2, intensity * 0.6);
    gl_FragColor = vec4(col, 1.0) * intensity * uIntensity;
  }
`;

export default function Atmosphere({ radius = 1.16, intensity = 1.35 }) {
  const uniforms = useMemo(
    () => ({
      uColor:     { value: new THREE.Color(HERO_COLORS.purple) },
      uColor2:    { value: new THREE.Color(HERO_COLORS.pink) },
      uIntensity: { value: intensity },
    }),
    [intensity],
  );

  return (
    <mesh scale={radius}>
      <sphereGeometry args={[1, 64, 64]} />
      <shaderMaterial
        vertexShader={VERT}
        fragmentShader={FRAG}
        uniforms={uniforms}
        side={THREE.BackSide}
        blending={THREE.AdditiveBlending}
        transparent
        depthWrite={false}
      />
    </mesh>
  );
}
